import { render, staticRenderFns } from "./SportTags.vue?vue&type=template&id=490190ac"
import script from "./SportTags.vue?vue&type=script&lang=js"
export * from "./SportTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports